import {ObjectSize, SymbolPosition} from '@fantasmagames/slot/src/modules/reels/ReelConstants';

/**
 * Symbol from spin response
 * Can be used in different context
 */
export class GameSymbol {
	protected _sym: number;
	protected _size: ObjectSize;
	protected _position: SymbolPosition;

	constructor(sym: number, size: ObjectSize, position?: SymbolPosition) {
		this._sym = sym;
		this._size = size;
		this._position = position;
	}

	public get sym(): number {
		return this._sym;
	}

	public get size(): ObjectSize {
		return this._size;
	}

	public get position(): SymbolPosition {
		return this._position;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/data/GameSymbol.ts